import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}
export const AboutThisGameModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="About" isOpen={isOpen} handleClose={handleClose}>
      <p>
        Waggle! is a game for pet lovers and an adaptation of the open-source
        clone of the game&nbsp;
        <a
          className="font-bold underline decoration-solid decoration-1"
          target="_blank"
          href="https://github.com/cwackerfuss/react-wordle"
          rel="noreferrer"
        >
          Wordle
        </a>
        .
      </p>
      <p>
        For more information about Wag!, please visit&nbsp;
        <a
          className="font-bold underline decoration-solid decoration-1"
          target="_blank"
          href="https://wagwalking.com"
          rel="noreferrer"
        >
          our website
        </a>
        .
      </p>
    </BaseModal>
  )
}
